import { requestHttp } from "../utils/HttpRequest";

export const getToSellingCustomersMetrics = (idUser, date) => {
  try {
    const response = requestHttp({
      endpoint: "top_selling_customers",
      data: {
        user_id: idUser,
        chosen_date: date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
